// Une fois que la page est chargée
window.addEventListener("DOMContentLoaded", () => {

  // Megamenu au survol (hover-intent : on temporise la fermeture pour éviter
  // qu'un mouseleave parasite — dû à un reflow du header au 1er chargement,
  // ex. chargement des polices — ne referme le dropdown juste après l'ouverture)
  var $megaDetails = $(".header__inline-menu details");
  $megaDetails.each(function () {
    var $details = $(this);
    var closeTimer;
    $details.on("mouseenter", function () {
      clearTimeout(closeTimer);
      // Ferme immédiatement les autres menus ouverts avant d'ouvrir celui-ci
      $megaDetails.not($details).removeAttr("open");
      $details.attr("open", true);
    });
    $details.on("mouseleave", function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        $details.removeAttr("open");
      }, 80);
    });
  });

  var headerSolidTimer;
  var pointerInHeader = false;

  function anyDropdownOpen() {
    if (!window.matchMedia("(min-width: 990px)").matches) return false;
    return !!document.querySelector(".header__inline-menu details[open]");
  }

  function headerIsSolid() {
    return pointerInHeader || anyDropdownOpen();
  }

  function syncHeaderSolid() {
    clearTimeout(headerSolidTimer);
    if (headerIsSolid()) {
      document.body.classList.add("header-hover-solid");
      return;
    }
    headerSolidTimer = setTimeout(function () {
      if (!headerIsSolid()) document.body.classList.remove("header-hover-solid");
    }, 100);
  }

  document.addEventListener("mouseover", function (event) {
    if (!event.target.closest || !event.target.closest(".section-header")) return;
    pointerInHeader = true;
    syncHeaderSolid();
  });

  document.addEventListener("mouseout", function (event) {
    if (!event.target.closest || !event.target.closest(".section-header")) return;
    if (event.relatedTarget && event.relatedTarget.closest && event.relatedTarget.closest(".section-header")) return;
    pointerInHeader = false;
    syncHeaderSolid();
  });

  initURLTarget(); // Initialise les data-url_target cliquables

  // Redirection reassurance item
  $(document).on('click', '.reassurance__item', function () {
    var url = $(this).find("a").attr("href");
    if (url) {
      window.location.href = url;
    }
  });

  function syncSearchModalState() {
    const opened = !!document.querySelector('details-modal details[open]');
    document.body.classList.toggle('overflow-hidden-modal-opened', opened);
  }

  new MutationObserver(function () {
    syncSearchModalState();
    syncHeaderSolid();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });

  syncSearchModalState();

  // Accordéons PDP (description, détails produit, AGEC)
  $(document).on('click', '.product-accordion__header', function () {
    var $accordion = $(this).closest('.product-accordion');
    var isOpen = $accordion.toggleClass('is-open').hasClass('is-open');
    $(this).attr('aria-expanded', isOpen);
    $accordion.find('.product-accordion__content').stop(true, true).slideToggle(300);
  });

  // Contenu SEO collection : dépliage slide up/down au clic sur le chevron
  function initCollectionSeo() {
    $('.collection-seo').each(function () {
      var $seo = $(this);
      if ($seo.hasClass('is-open')) return; // ne pas recalculer si déplié
      var text = $seo.find('.collection-seo__text')[0];
      if (!text) return;
      // Si le texte tient déjà en 4 lignes : pas de fondu ni de chevron
      var fits = text.scrollHeight <= text.clientHeight + 2;
      $seo.toggleClass('collection-seo--fits', fits);
      $seo.find('.collection-seo__toggle').toggle(!fits);
    });
  }
  initCollectionSeo();
  $(window).on('load resize', initCollectionSeo);

  $(document).on('click', '.collection-seo__toggle', function () {
    var $seo = $(this).closest('.collection-seo');
    var $text = $seo.find('.collection-seo__text');
    var isOpen = $seo.toggleClass('is-open').hasClass('is-open');
    $(this).attr('aria-expanded', isOpen);
    $text.css('max-height', isOpen ? $text[0].scrollHeight + 'px' : '');
  });

  // Ouverture et fermeture guide des tailles
  $(document).on('click', '.sizing_guide', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_sizing.drawer").addClass("active");
  });

  $(document).on('click', '#drawer_sizing.drawer .icon-close, #drawer_sizing.drawer', function () {
    $("#drawer_sizing.drawer").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("overflow-hidden");
    }, 800);
  });

  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").addClass("active");
  });

  $(document).on('click', '#drawer_disponibilite.drawer .icon-close, #drawer_disponibilite.drawer', function () {
    $("#drawer_disponibilite.popin_shop_availability").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("overflow-hidden");
    }, 800);
  });

  // Fermeture des popins au clic en dehors de la popin
  $(document).on('click', '.drawer_wrapper_inner', function (event) {
    event.stopPropagation();
  });

  // Mention légale newsletter : visible dès que le champ email est rempli
  function toggleNewsletterLegal(input) {
    var $legal = $(input).closest('.newsletter-form').find('[data-newsletter-legal]');
    if (!$legal.length) return;
    $legal.prop('hidden', $.trim(input.value) === '');
  }

  // change couvre l'autofill navigateur, qui ne déclenche pas toujours input
  $(document).on('input change', '.newsletter-form input[type="email"]', function () {
    toggleNewsletterLegal(this);
  });

  $('.newsletter-form input[type="email"]').each(function () {
    toggleNewsletterLegal(this);
  });

  // Page collection
  // ----------------------------------------------------------------------------
  // Filtres
  // Ouverture tabs
  $(document).on("click", ".mobile-facets__summary", function () {
    $(this).toggleClass("active");
    $(this).next().toggle();
  });

  // Quick add to card PLP
    $(document).on("click", "[data-card_product_variant_id]", function (e) {
    // prevent default action
    e.preventDefault();
    // prevent propagation
    e.stopPropagation();

    // si l'élément cliqué à une classe "disabled" on ne fait rien
    if ($(this).hasClass("disabled")) {
      return;
    }

    var $this = $(this);
    var variantId = $this.data("card_product_variant_id");
    var $form = $this.closest("product-form");
    var $input = $form.find('input[name="id"]');

    if ($input.length) {
      $input.val(variantId);
      $form.trigger("change");
    }
     $(this).closest('form').find('.quick-add__submit').click();
  });

  // Voir plus
  if ($(".clamped").length) {
  $(document).on("click", ".read_more", function () {
    var $clamped = $(this).prev(".clamped");

    if (!$clamped.hasClass("extend")) {
      // OUVRIR
      $clamped.css("height", $clamped.prop("scrollHeight") + "px");
      $clamped.addClass("extend");
    } else {
      // FERMER
      $clamped.css("height", "");
      $clamped.removeClass("extend");

      var $section = $clamped.closest('[class*="section-"][class*="-padding"]');

      if ($section.length) {
        $("html, body").animate(
          {
            scrollTop: $section.offset().top - 60,
          },
          400
        );
      }
    }

    $(this).find(".show, .hide").toggleClass("show hide");
  });
}

  // accordeon
   // Comportement questions FAQ, CGV, Mentions
   $(".accordeon").on("click", "h3", function () {
    var $currentQ = $(this);
    var $currentA = $currentQ.next("div");

    // Ferme toutes les autres réponses + retire leurs classes
    $(".accordeon h3").not($currentQ).removeClass("opened");
    $(".accordeon h3").not($currentQ).next("div").stop(true, true).slideUp();

    // Toggle sur l'élément cliqué
    if ($currentQ.hasClass("opened")) {
      $currentQ.removeClass("opened");
      $currentA.stop(true, true).slideUp();
    } else {
      $currentQ.addClass("opened");
      $currentA.stop(true, true).slideDown();
    }
  });

  // Fibble
  $("fibbl-layer").on('fibbl-ready', function () {
    $("#fibbl_vto_button_active").show();
  });

  // Footer
  // ----------------------------------------------------------------------------
  // Accordeon Footer mobile
  function footerAccordion() {
    if ($(window).width() <= 749) {
      $('.footer-block__details-content').hide();

      $('.footer-block__heading').off('click').on('click', function () {
        const $block = $(this).closest('.footer-block');
        const $content = $block.find('.footer-block__details-content');

        $(this).toggleClass('is-open');
        $content.stop(true, true).slideToggle(300);
      });
    } else {
      $('.footer-block__details-content').show();
      $('.footer-block__heading').removeClass('is-open').off('click');
    }
  }

  footerAccordion();
  $(window).on('resize', footerAccordion);

  // Swiper quicklinks
  var variantListPdpSwiper = new Swiper(".quicklinks_wrapper", {
    maxBackfaceHiddenSlides: 0,
    slidesPerView: "auto",
    grabCursor: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
  });
});

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
// Délégation : couvre aussi les éléments insérés après le chargement (scroll infini, filtres).
function initURLTarget() {
  document.addEventListener("click", (event) => {
    const element = event.target.closest("[data-url_target]");
    if (!element) return;
    const url = element.dataset.url_target;
    if (url && url !== "#") {
      window.location.href = url;
    }
  });
}

// Instagram swiper
class InstagramSwiper extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3;
    this.slidesPerView = parseInt(this.dataset.slidesPerView) || 4;
    this.spaceBetween = parseInt(this.dataset.spaceBetween) || 24;
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const slidesCount = this.querySelectorAll('.swiper .swiper-slide').length;
    const swiperConfig = {
      maxBackfaceHiddenSlides: 0,
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween,
      loop: slidesCount > 1,
      loopAdditionalSlides: 2,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        750: {
          slidesPerView: this.slidesPerView,
          spaceBetween: this.spaceBetween,
        },
      },
    };

    // Ajouter l'autoplay si activé
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(this.querySelector(".swiper"), swiperConfig);

    // Empêcher la propagation des clics sur les contrôles
    this.querySelectorAll(".swiper-button-next, .swiper-button-prev").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("instagram-swiper", InstagramSwiper);

class CardProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwipers();
  }

  initSwipers() {
    $(this).find(".mySwiper").not(".no-swiper").each(function () {
      var $swiperContainer = $(this);
      var swiperElement = $swiperContainer.get(0);

      // Already initialized swiper, skip
      if (swiperElement?.swiper) return;

      // Clean old swiper classes from cached HTML before init
      $swiperContainer
        .removeClass("swiper-initialized swiper-horizontal swiper-backface-hidden")
        .find(".swiper-wrapper, .swiper-slide")
        .removeAttr("style");

      var slidesCount = $swiperContainer.find(".swiper-slide").length;
      var hasMultipleSlides = slidesCount > 1;
      var nextEl = $swiperContainer.find(".swiper-button-next").get(0);
      var prevEl = $swiperContainer.find(".swiper-button-prev").get(0);
      var paginationEl = $swiperContainer.find(".swiper-pagination").get(0);

      $swiperContainer.toggleClass("is-single-slide", !hasMultipleSlides);

      var disableMobileTouch = $swiperContainer.hasClass("no-mobile-swiper");
      // Si la carte est un slide d'un carrousel de cartes, on désactive le swipe
      // d'image en desktop pour laisser le drag déplacer le carrousel de cartes
      // (les flèches au survol restent dispo pour changer d'image).
      var inCardCarousel = $swiperContainer.closest(".slider__slide").length > 0;

      new Swiper(swiperElement, {
        maxBackfaceHiddenSlides: 0,
        loop: hasMultipleSlides,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
          enabled: hasMultipleSlides,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        preventClicks: true,
        preventClicksPropagation: true,
        breakpoints: {
          0: { allowTouchMove: !disableMobileTouch },
          789: { allowTouchMove: !inCardCarousel },
        }
      });

      $swiperContainer.find(".swiper-button-next, .swiper-button-prev").off("click.cardSwiper").on("click.cardSwiper", function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }

}
customElements.define("card-product", CardProduct);